module.exports = __webpack_public_path__ + "static/img/che09.5f9b006.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/che09.png
// module id = k9XA
// module chunks = 1